// This file is auto-generated by @hey-api/openapi-ts
import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type {
  ActionsCreateActionData,
  ActionsCreateActionResponse,
  ActionsDeleteActionData,
  ActionsDeleteActionResponse,
  ActionsReadActionData,
  ActionsReadActionResponse,
  ActionsReadActionsData,
  ActionsReadActionsResponse,
  ActionsUpdateActionData,
  ActionsUpdateActionResponse,
  CommitmentGoalsCreateGoalData,
  CommitmentGoalsCreateGoalResponse,
  CommitmentGoalsDeleteGoalData,
  CommitmentGoalsDeleteGoalResponse,
  CommitmentGoalsReadGoalsData,
  CommitmentGoalsReadGoalsResponse,
  CommitmentGoalsUpdateGoalData,
  CommitmentGoalsUpdateGoalResponse,
  CommitmentsCreateCommitmentData,
  CommitmentsCreateCommitmentResponse,
  CommitmentsDeleteCommitmentData,
  CommitmentsDeleteCommitmentResponse,
  CommitmentsUpdateCommitmentData,
  CommitmentsUpdateCommitmentResponse,
  CompaniesCreateCompanyData,
  CompaniesCreateCompanyResponse,
  CompaniesDeleteCompanyData,
  CompaniesDeleteCompanyResponse,
  CompaniesReadCompaniesData,
  CompaniesReadCompaniesNotAlreadyJoinedResponse,
  CompaniesReadCompaniesResponse,
  CompaniesReadCompanyData,
  CompaniesReadCompanyResponse,
  CompaniesReadCompanyUsersData,
  CompaniesReadCompanyUsersResponse,
  CompaniesUpdateCompanyData,
  CompaniesUpdateCompanyResponse,
  CsrPlansReadCsrPlanCommitmentsData,
  CsrPlansReadCsrPlanCommitmentsResponse,
  CsrPlansReadCsrPlanData,
  CsrPlansReadCsrPlanPillarsData,
  CsrPlansReadCsrPlanPillarsResponse,
  CsrPlansReadCsrPlanResponse,
  EntitiesReadEntitiesData,
  EntitiesReadEntitiesResponse,
  HealthCheckExplicitResponse,
  HealthCheckRootResponse,
  IndicatorsCreateIndicatorData,
  IndicatorsCreateIndicatorResponse,
  IndicatorsDeleteIndicatorData,
  IndicatorsDeleteIndicatorResponse,
  IndicatorsDeleteIndicatorYearSettingsData,
  IndicatorsDeleteIndicatorYearSettingsResponse,
  IndicatorsDuplicateYearData,
  IndicatorsDuplicateYearResponse,
  IndicatorsPeriodsReadIndicatorPeriodData,
  IndicatorsPeriodsReadIndicatorPeriodResponse,
  IndicatorsPeriodsReadIndicatorPeriodsData,
  IndicatorsPeriodsReadIndicatorPeriodsResponse,
  IndicatorsPeriodsUpdateIndicatorPeriodData,
  IndicatorsPeriodsUpdateIndicatorPeriodResponse,
  IndicatorsReadIndicatorData,
  IndicatorsReadIndicatorResponse,
  IndicatorsReadIndicatorSummaryData,
  IndicatorsReadIndicatorSummaryResponse,
  IndicatorsReadIndicatorUnitsData,
  IndicatorsReadIndicatorUnitsResponse,
  IndicatorsReadIndicatorYearSettingsData,
  IndicatorsReadIndicatorYearSettingsEntitiesData,
  IndicatorsReadIndicatorYearSettingsEntitiesResponse,
  IndicatorsReadIndicatorYearSettingsResponse,
  IndicatorsReadIndicatorsData,
  IndicatorsReadIndicatorsProgressionData,
  IndicatorsReadIndicatorsProgressionResponse,
  IndicatorsReadIndicatorsResponse,
  IndicatorsRecalculateIndicatorYearSettingsData,
  IndicatorsRecalculateIndicatorYearSettingsResponse,
  IndicatorsUpdateIndicatorData,
  IndicatorsUpdateIndicatorResponse,
  IndicatorsUpdateIndicatorYearSettingsData,
  IndicatorsUpdateIndicatorYearSettingsResponse,
  IndicatorsYearSettingsCreateIndicatorYearSettingData,
  IndicatorsYearSettingsCreateIndicatorYearSettingResponse,
  IndicatorsYearSettingsDeleteIndicatorYearSettingData,
  IndicatorsYearSettingsDeleteIndicatorYearSettingResponse,
  IndicatorsYearSettingsReadIndicatorYearSettingByYearData,
  IndicatorsYearSettingsReadIndicatorYearSettingByYearResponse,
  IndicatorsYearSettingsReadIndicatorYearSettingData,
  IndicatorsYearSettingsReadIndicatorYearSettingResponse,
  IndicatorsYearSettingsReadIndicatorYearSettingsData,
  IndicatorsYearSettingsReadIndicatorYearSettingsResponse,
  IndicatorsYearSettingsUpdateIndicatorYearSettingByYearData,
  IndicatorsYearSettingsUpdateIndicatorYearSettingByYearResponse,
  IndicatorsYearSettingsUpdateIndicatorYearSettingData,
  IndicatorsYearSettingsUpdateIndicatorYearSettingResponse,
  LibraryCreateIndicatorFromSuggestionData,
  LibraryCreateIndicatorFromSuggestionResponse,
  LibraryReadIndicatorUnitsData,
  LibraryReadIndicatorUnitsResponse,
  LibraryReadLibraryActionData,
  LibraryReadLibraryActionResponse,
  LibraryReadLibraryActionsData,
  LibraryReadLibraryActionsResponse,
  LibraryReadLibraryCatalogsData,
  LibraryReadLibraryCatalogsResponse,
  LibraryReadLibraryIndicatorData,
  LibraryReadLibraryIndicatorResponse,
  LibraryReadLibraryIndicatorsData,
  LibraryReadLibraryIndicatorsResponse,
  PillarsCreatePillarData,
  PillarsCreatePillarResponse,
  PillarsDeletePillarData,
  PillarsDeletePillarResponse,
  PillarsUpdatePillarData,
  PillarsUpdatePillarResponse,
  StatsReadActionsStatsData,
  StatsReadActionsStatsResponse,
  StatsReadIndicatorsStatsData,
  StatsReadIndicatorsStatsResponse,
  StatsReadMainStatsData,
  StatsReadMainStatsResponse,
  StatsReadMembersStatsData,
  StatsReadMembersStatsResponse,
  UsersCreateUserData,
  UsersCreateUserResponse,
  UsersDeleteUserData,
  UsersDeleteUserResponse,
  UsersReadUserByIdData,
  UsersReadUserByIdResponse,
  UsersReadUserMeData,
  UsersReadUserMeResponse,
  UsersReadUsersData,
  UsersReadUsersResponse,
  UsersUpdateUserData,
  UsersUpdateUserMeData,
  UsersUpdateUserMeResponse,
  UsersUpdateUserResponse,
  UtilsReadReferentialsData,
  UtilsReadReferentialsKeysData,
  UtilsReadReferentialsKeysResponse,
  UtilsReadReferentialsResponse,
  UtilsReadSdgsResponse,
} from './types.gen';

export class ActionsService {
  /**
   * Read Actions
   * Retrieve actions.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.offset
   * @param data.limit
   * @param data.sort
   * @param data.filter
   * @param data.search
   * @returns ActionsPublic Successful Response
   * @throws ApiError
   */
  public static readActions(data: ActionsReadActionsData): CancelablePromise<ActionsReadActionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/actions/',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create Action
   * Create new action.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns ActionPublic Successful Response
   * @throws ApiError
   */
  public static createAction(data: ActionsCreateActionData): CancelablePromise<ActionsCreateActionResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/actions/',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Action
   * Get action by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns ActionPublic Successful Response
   * @throws ApiError
   */
  public static readAction(data: ActionsReadActionData): CancelablePromise<ActionsReadActionResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/actions/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Action
   * Update an action.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @returns ActionPublic Successful Response
   * @throws ApiError
   */
  public static updateAction(data: ActionsUpdateActionData): CancelablePromise<ActionsUpdateActionResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/actions/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Action
   * Delete an action.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteAction(data: ActionsDeleteActionData): CancelablePromise<ActionsDeleteActionResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/actions/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class CommitmentGoalsService {
  /**
   * Read Goals
   * Retrieve goals.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.offset
   * @param data.limit
   * @param data.sort
   * @param data.filter
   * @param data.search
   * @returns CommitmentsGoalPublic Successful Response
   * @throws ApiError
   */
  public static readGoals(data: CommitmentGoalsReadGoalsData): CancelablePromise<CommitmentGoalsReadGoalsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/goals/',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create Goal
   * Create new commitment goal.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns CommitmentGoalPublic Successful Response
   * @throws ApiError
   */
  public static createGoal(data: CommitmentGoalsCreateGoalData): CancelablePromise<CommitmentGoalsCreateGoalResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/goals/',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Goal
   * Update a commitment goal with id
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @returns CommitmentGoalPublic Successful Response
   * @throws ApiError
   */
  public static updateGoal(data: CommitmentGoalsUpdateGoalData): CancelablePromise<CommitmentGoalsUpdateGoalResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/goals/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Goal
   * Delete a commitment goal.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteGoal(data: CommitmentGoalsDeleteGoalData): CancelablePromise<CommitmentGoalsDeleteGoalResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/goals/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class CommitmentsService {
  /**
   * Create Commitment
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns CommitmentCreate Successful Response
   * @throws ApiError
   */
  public static createCommitment(
    data: CommitmentsCreateCommitmentData
  ): CancelablePromise<CommitmentsCreateCommitmentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/commitment/',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Commitment
   * Update a commitment with id
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @returns CommitmentPublic Successful Response
   * @throws ApiError
   */
  public static updateCommitment(
    data: CommitmentsUpdateCommitmentData
  ): CancelablePromise<CommitmentsUpdateCommitmentResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/commitment/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Commitment
   * Delete a commitment.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteCommitment(
    data: CommitmentsDeleteCommitmentData
  ): CancelablePromise<CommitmentsDeleteCommitmentResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/commitment/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class CompaniesService {
  /**
   * Read Companies
   * Retrieve companies.
   * @param data The data for the request.
   * @param data.offset
   * @param data.limit
   * @param data.sort Sort parameters (e.g., slug,-name)
   * @param data.filters Filter parameters (e.g., name=test)
   * @returns CompaniesPublic Successful Response
   * @throws ApiError
   */
  public static readCompanies(
    data: CompaniesReadCompaniesData = {}
  ): CancelablePromise<CompaniesReadCompaniesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/',
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filters: data.filters,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create Company
   * Create new company.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CompanyPublic Successful Response
   * @throws ApiError
   */
  public static createCompany(data: CompaniesCreateCompanyData): CancelablePromise<CompaniesCreateCompanyResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Companies Not Already Joined
   * Retrieve companies not already joined.
   * @returns KeycloakGroup Successful Response
   * @throws ApiError
   */
  public static readCompaniesNotAlreadyJoined(): CancelablePromise<CompaniesReadCompaniesNotAlreadyJoinedResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/not-already-joined',
    });
  }

  /**
   * Read Company
   * Get company by ID.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns CompanyPublic Successful Response
   * @throws ApiError
   */
  public static readCompany(data: CompaniesReadCompanyData): CancelablePromise<CompaniesReadCompanyResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Company
   * Update an company.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns CompanyPublic Successful Response
   * @throws ApiError
   */
  public static updateCompany(data: CompaniesUpdateCompanyData): CancelablePromise<CompaniesUpdateCompanyResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Company
   * Delete an company.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteCompany(data: CompaniesDeleteCompanyData): CancelablePromise<CompaniesDeleteCompanyResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Company Users
   * Retrieve companies.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.offset
   * @param data.limit
   * @param data.sort Sort parameters (e.g., slug,-name)
   * @param data.filters Filter parameters (e.g., name=test)
   * @returns UsersPublic Successful Response
   * @throws ApiError
   */
  public static readCompanyUsers(
    data: CompaniesReadCompanyUsersData
  ): CancelablePromise<CompaniesReadCompanyUsersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/users',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filters: data.filters,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class CsrPlansService {
  /**
   * Read Csr Plan
   * Get csr_plan
   * @param data The data for the request.
   * @param data.companySlug
   * @returns CsrPlanPublic Successful Response
   * @throws ApiError
   */
  public static readCsrPlan(data: CsrPlansReadCsrPlanData): CancelablePromise<CsrPlansReadCsrPlanResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/csr_plan/',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Csr Plan Pillars
   * Get pillars
   * @param data The data for the request.
   * @param data.companySlug
   * @returns PillarsPublic Successful Response
   * @throws ApiError
   */
  public static readCsrPlanPillars(
    data: CsrPlansReadCsrPlanPillarsData
  ): CancelablePromise<CsrPlansReadCsrPlanPillarsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/csr_plan/pillars',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Csr Plan Commitments
   * Get commitments
   * @param data The data for the request.
   * @param data.companySlug
   * @returns CommitmentsPublic Successful Response
   * @throws ApiError
   */
  public static readCsrPlanCommitments(
    data: CsrPlansReadCsrPlanCommitmentsData
  ): CancelablePromise<CsrPlansReadCsrPlanCommitmentsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/csr_plan/commitments',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class EntitiesService {
  /**
   * Read Entities
   * Retrieve companies.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns EntitiesPublic Successful Response
   * @throws ApiError
   */
  public static readEntities(data: EntitiesReadEntitiesData): CancelablePromise<EntitiesReadEntitiesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/entities/',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class IndicatorsService {
  /**
   * Read Indicators
   * Retrieve companies.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.offset
   * @param data.limit
   * @param data.sort
   * @param data.filter
   * @param data.search
   * @returns IndicatorsPublic Successful Response
   * @throws ApiError
   */
  public static readIndicators(
    data: IndicatorsReadIndicatorsData
  ): CancelablePromise<IndicatorsReadIndicatorsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create Indicator
   * Create new indicator.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns IndicatorPublic Successful Response
   * @throws ApiError
   */
  public static createIndicator(
    data: IndicatorsCreateIndicatorData
  ): CancelablePromise<IndicatorsCreateIndicatorResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/indicators/',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicators Progression
   * Retrieve indicators progression.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns IndicatorsProgression Successful Response
   * @throws ApiError
   */
  public static readIndicatorsProgression(
    data: IndicatorsReadIndicatorsProgressionData
  ): CancelablePromise<IndicatorsReadIndicatorsProgressionResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/progression',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Year Settings
   * Retrieve indicator year settings.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.offset
   * @param data.limit
   * @param data.sort
   * @param data.filter
   * @param data.search
   * @returns IndicatorYearSettingsManagesPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorYearSettings(
    data: IndicatorsReadIndicatorYearSettingsData
  ): CancelablePromise<IndicatorsReadIndicatorYearSettingsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/settings/{year}',
      path: {
        year: data.year,
        company_slug: data.companySlug,
      },
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Indicator Year Settings
   * Update an indicator.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.requestBody
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static updateIndicatorYearSettings(
    data: IndicatorsUpdateIndicatorYearSettingsData
  ): CancelablePromise<IndicatorsUpdateIndicatorYearSettingsResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/indicators/settings/{year}',
      path: {
        year: data.year,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Indicator Year Settings
   * Delete an indicator.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.requestBody
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteIndicatorYearSettings(
    data: IndicatorsDeleteIndicatorYearSettingsData
  ): CancelablePromise<IndicatorsDeleteIndicatorYearSettingsResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/indicators/settings/{year}',
      path: {
        year: data.year,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Year Settings Entities
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.requestBody
   * @returns IndicatorYearEntitiesStatus Successful Response
   * @throws ApiError
   */
  public static readIndicatorYearSettingsEntities(
    data: IndicatorsReadIndicatorYearSettingsEntitiesData
  ): CancelablePromise<IndicatorsReadIndicatorYearSettingsEntitiesResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/indicators/settings/{year}/entities',
      path: {
        year: data.year,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Recalculate Indicator Year Settings
   * Recalculate indicator year settings.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static recalculateIndicatorYearSettings(
    data: IndicatorsRecalculateIndicatorYearSettingsData
  ): CancelablePromise<IndicatorsRecalculateIndicatorYearSettingsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/settings/{year}/recalculate',
      path: {
        year: data.year,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Units
   * Retrieve indicators units.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns Units Successful Response
   * @throws ApiError
   */
  public static readIndicatorUnits(
    data: IndicatorsReadIndicatorUnitsData
  ): CancelablePromise<IndicatorsReadIndicatorUnitsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/units',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator
   * Get company by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns IndicatorDetailsPublic Successful Response
   * @throws ApiError
   */
  public static readIndicator(data: IndicatorsReadIndicatorData): CancelablePromise<IndicatorsReadIndicatorResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Indicator
   * Update an indicator.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @returns IndicatorDetailsPublic Successful Response
   * @throws ApiError
   */
  public static updateIndicator(
    data: IndicatorsUpdateIndicatorData
  ): CancelablePromise<IndicatorsUpdateIndicatorResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/indicators/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Indicator
   * Delete an indicator.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteIndicator(
    data: IndicatorsDeleteIndicatorData
  ): CancelablePromise<IndicatorsDeleteIndicatorResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/indicators/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Summary
   * Get company by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns IndicatorSummaryPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorSummary(
    data: IndicatorsReadIndicatorSummaryData
  ): CancelablePromise<IndicatorsReadIndicatorSummaryResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/{id}/summary',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Duplicate Year
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.targetYear
   * @param data.sourceYear
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static duplicateYear(data: IndicatorsDuplicateYearData): CancelablePromise<IndicatorsDuplicateYearResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/indicators/duplicate',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        target_year: data.targetYear,
        source_year: data.sourceYear,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class IndicatorsPeriodsService {
  /**
   * Read Indicator Periods
   * Retrieve indicator periods.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.period
   * @param data.periodNumber
   * @param data.entityId
   * @param data.offset
   * @param data.limit
   * @param data.filters Filter parameters (e.g., name=test)
   * @param data.sort Sort parameters (e.g., sort=name:desc)
   * @param data.search
   * @returns IndicatorYearPeriodsPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorPeriods(
    data: IndicatorsPeriodsReadIndicatorPeriodsData
  ): CancelablePromise<IndicatorsPeriodsReadIndicatorPeriodsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/periods/{year}',
      path: {
        year: data.year,
        company_slug: data.companySlug,
      },
      query: {
        period: data.period,
        period_number: data.periodNumber,
        entity_id: data.entityId,
        offset: data.offset,
        limit: data.limit,
        filters: data.filters,
        sort: data.sort,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Period
   * Get indicator period by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns IndicatorYearPeriodPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorPeriod(
    data: IndicatorsPeriodsReadIndicatorPeriodData
  ): CancelablePromise<IndicatorsPeriodsReadIndicatorPeriodResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/periods/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Indicator Period
   * Update an indicator period.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @param data.returnUpdated
   * @param data.disableCalculate
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public static updateIndicatorPeriod(
    data: IndicatorsPeriodsUpdateIndicatorPeriodData
  ): CancelablePromise<IndicatorsPeriodsUpdateIndicatorPeriodResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/indicators/periods/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      query: {
        return_updated: data.returnUpdated,
        disableCalculate: data.disableCalculate,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class IndicatorsYearSettingsService {
  /**
   * Read Indicator Year Settings
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.indicatorId
   * @param data.offset
   * @param data.limit
   * @param data.sort Sort parameters (e.g., sort=name:desc)
   * @param data.filter
   * @returns IndicatorYearSettingsPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorYearSettings(
    data: IndicatorsYearSettingsReadIndicatorYearSettingsData
  ): CancelablePromise<IndicatorsYearSettingsReadIndicatorYearSettingsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/',
      path: {
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      query: {
        offset: data.offset,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create Indicator Year Setting
   * Create new indicator year setting.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.indicatorId
   * @param data.requestBody
   * @returns IndicatorYearSettingPublic Successful Response
   * @throws ApiError
   */
  public static createIndicatorYearSetting(
    data: IndicatorsYearSettingsCreateIndicatorYearSettingData
  ): CancelablePromise<IndicatorsYearSettingsCreateIndicatorYearSettingResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/',
      path: {
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Year Setting
   * Get indicator year setting by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.indicatorId
   * @returns IndicatorYearSettingPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorYearSetting(
    data: IndicatorsYearSettingsReadIndicatorYearSettingData
  ): CancelablePromise<IndicatorsYearSettingsReadIndicatorYearSettingResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Indicator Year Setting
   * Update an indicator year setting.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.indicatorId
   * @param data.requestBody
   * @returns IndicatorYearSettingPublic Successful Response
   * @throws ApiError
   */
  public static updateIndicatorYearSetting(
    data: IndicatorsYearSettingsUpdateIndicatorYearSettingData
  ): CancelablePromise<IndicatorsYearSettingsUpdateIndicatorYearSettingResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Indicator Year Setting
   * Delete an indicator year setting.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.indicatorId
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteIndicatorYearSetting(
    data: IndicatorsYearSettingsDeleteIndicatorYearSettingData
  ): CancelablePromise<IndicatorsYearSettingsDeleteIndicatorYearSettingResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Year Setting By Year
   * Get indicator year setting by ID.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.indicatorId
   * @returns IndicatorYearSettingPublic Successful Response
   * @throws ApiError
   */
  public static readIndicatorYearSettingByYear(
    data: IndicatorsYearSettingsReadIndicatorYearSettingByYearData
  ): CancelablePromise<IndicatorsYearSettingsReadIndicatorYearSettingByYearResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/year/{year}',
      path: {
        year: data.year,
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Indicator Year Setting By Year
   * Update an indicator year setting.
   * @param data The data for the request.
   * @param data.year
   * @param data.companySlug
   * @param data.indicatorId
   * @param data.requestBody
   * @returns IndicatorYearSettingPublic Successful Response
   * @throws ApiError
   */
  public static updateIndicatorYearSettingByYear(
    data: IndicatorsYearSettingsUpdateIndicatorYearSettingByYearData
  ): CancelablePromise<IndicatorsYearSettingsUpdateIndicatorYearSettingByYearResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/indicators/{indicator_id}/settings/year/{year}',
      path: {
        year: data.year,
        company_slug: data.companySlug,
        indicator_id: data.indicatorId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class LibraryService {
  /**
   * Read Library Catalogs
   * Retrieve catalogs.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns CatalogsPublic Successful Response
   * @throws ApiError
   */
  public static readLibraryCatalogs(
    data: LibraryReadLibraryCatalogsData
  ): CancelablePromise<LibraryReadLibraryCatalogsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/library/catalogs/',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Library Indicators
   * Retrieve indicators.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.skip
   * @param data.limit
   * @param data.sort
   * @param data.filter
   * @param data.search
   * @returns IndicatorSuggestionsPublic Successful Response
   * @throws ApiError
   */
  public static readLibraryIndicators(
    data: LibraryReadLibraryIndicatorsData
  ): CancelablePromise<LibraryReadLibraryIndicatorsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/library/indicators/',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        skip: data.skip,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicator Units
   * Retrieve indicators units.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns Units Successful Response
   * @throws ApiError
   */
  public static readIndicatorUnits(
    data: LibraryReadIndicatorUnitsData
  ): CancelablePromise<LibraryReadIndicatorUnitsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/library/indicators/units',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Library Indicator
   * Get company by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns IndicatorSuggestionDetailsPublic Successful Response
   * @throws ApiError
   */
  public static readLibraryIndicator(
    data: LibraryReadLibraryIndicatorData
  ): CancelablePromise<LibraryReadLibraryIndicatorResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/library/indicators/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create Indicator From Suggestion
   * Create new indicator from suggestion.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @returns IndicatorPublic Successful Response
   * @throws ApiError
   */
  public static createIndicatorFromSuggestion(
    data: LibraryCreateIndicatorFromSuggestionData
  ): CancelablePromise<LibraryCreateIndicatorFromSuggestionResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/library/indicators/{id}/create',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Library Actions
   * Retrieve actions.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.skip
   * @param data.limit
   * @param data.sort
   * @param data.filter
   * @param data.search
   * @returns ActionSuggestionsPublic Successful Response
   * @throws ApiError
   */
  public static readLibraryActions(
    data: LibraryReadLibraryActionsData
  ): CancelablePromise<LibraryReadLibraryActionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/library/actions/',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        skip: data.skip,
        limit: data.limit,
        sort: data.sort,
        filter: data.filter,
        search: data.search,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Library Action
   * Get company by ID.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns ActionSuggestionDetailsPublic Successful Response
   * @throws ApiError
   */
  public static readLibraryAction(
    data: LibraryReadLibraryActionData
  ): CancelablePromise<LibraryReadLibraryActionResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/library/actions/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class PillarsService {
  /**
   * Create Pillar
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns PillarCreate Successful Response
   * @throws ApiError
   */
  public static createPillar(data: PillarsCreatePillarData): CancelablePromise<PillarsCreatePillarResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/pillar/',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update Pillar
   * Update a pillar with id
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @param data.requestBody
   * @returns PillarPublic Successful Response
   * @throws ApiError
   */
  public static updatePillar(data: PillarsUpdatePillarData): CancelablePromise<PillarsUpdatePillarResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/companies/{company_slug}/pillar/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete Pillar
   * Delete a pillar.
   * @param data The data for the request.
   * @param data.id
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deletePillar(data: PillarsDeletePillarData): CancelablePromise<PillarsDeletePillarResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/pillar/{id}',
      path: {
        id: data.id,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class StatsService {
  /**
   * Read Main Stats
   * Retrieve actions, indicators, and members statistics for a company.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns MainStat Successful Response
   * @throws ApiError
   */
  public static readMainStats(data: StatsReadMainStatsData): CancelablePromise<StatsReadMainStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/stats/main',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Members Stats
   * Retrieve actions, indicators, and members statistics for a company.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns MembersStat Successful Response
   * @throws ApiError
   */
  public static readMembersStats(data: StatsReadMembersStatsData): CancelablePromise<StatsReadMembersStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/stats/members',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Actions Stats
   * Retrieve actions, indicators, and members statistics for a company.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns ActionsStat Successful Response
   * @throws ApiError
   */
  public static readActionsStats(data: StatsReadActionsStatsData): CancelablePromise<StatsReadActionsStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/stats/actions',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Indicators Stats
   * @param data The data for the request.
   * @param data.companySlug
   * @returns IndicatorsStat Successful Response
   * @throws ApiError
   */
  public static readIndicatorsStats(
    data: StatsReadIndicatorsStatsData
  ): CancelablePromise<StatsReadIndicatorsStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/stats/indicators',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class UsersService {
  /**
   * Read Users
   * Retrieve users.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.skip
   * @param data.limit
   * @param data.sort Sort parameters (e.g., name:desc)
   * @param data.filterParametersEGNameTest
   * @returns UsersPublic Successful Response
   * @throws ApiError
   */
  public static readUsers(data: UsersReadUsersData): CancelablePromise<UsersReadUsersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/users/',
      path: {
        company_slug: data.companySlug,
      },
      query: {
        skip: data.skip,
        limit: data.limit,
        sort: data.sort,
        'Filter parameters (e.g., name=test)': data.filterParametersEGNameTest,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Create User
   * Create new user.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns UserPublic Successful Response
   * @throws ApiError
   */
  public static createUser(data: UsersCreateUserData): CancelablePromise<UsersCreateUserResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/companies/{company_slug}/users/',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update User Me
   * Update own user.
   * @param data The data for the request.
   * @param data.companySlug
   * @param data.requestBody
   * @returns UserPublic Successful Response
   * @throws ApiError
   */
  public static updateUserMe(data: UsersUpdateUserMeData): CancelablePromise<UsersUpdateUserMeResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/companies/{company_slug}/users/me',
      path: {
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read User Me
   * Get current user.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns UserPublic Successful Response
   * @throws ApiError
   */
  public static readUserMe(data: UsersReadUserMeData): CancelablePromise<UsersReadUserMeResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/users/me',
      path: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read User By Id
   * Get a specific user by id.
   * @param data The data for the request.
   * @param data.userId
   * @param data.companySlug
   * @returns UserPublic Successful Response
   * @throws ApiError
   */
  public static readUserById(data: UsersReadUserByIdData): CancelablePromise<UsersReadUserByIdResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/companies/{company_slug}/users/{user_id}',
      path: {
        user_id: data.userId,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Update User
   * Update a user.
   * @param data The data for the request.
   * @param data.userId
   * @param data.companySlug
   * @param data.requestBody
   * @returns UserPublic Successful Response
   * @throws ApiError
   */
  public static updateUser(data: UsersUpdateUserData): CancelablePromise<UsersUpdateUserResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/companies/{company_slug}/users/{user_id}',
      path: {
        user_id: data.userId,
        company_slug: data.companySlug,
      },
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Delete User
   * Delete a user.
   * @param data The data for the request.
   * @param data.userId
   * @param data.companySlug
   * @returns Message Successful Response
   * @throws ApiError
   */
  public static deleteUser(data: UsersDeleteUserData): CancelablePromise<UsersDeleteUserResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/companies/{company_slug}/users/{user_id}',
      path: {
        user_id: data.userId,
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}

export class UtilsService {
  /**
   * Health Check
   * @returns boolean Successful Response
   * @throws ApiError
   */
  public static healthCheckExplicit(): CancelablePromise<HealthCheckExplicitResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/utils/health-check/',
    });
  }

  /**
   * Health Check
   * @returns boolean Successful Response
   * @throws ApiError
   */
  public static healthCheckRoot(): CancelablePromise<HealthCheckRootResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/utils/',
    });
  }

  /**
   * Read Sdgs
   * Retrieve sdgs.
   * @returns SDGsPublic Successful Response
   * @throws ApiError
   */
  public static readSdgs(): CancelablePromise<UtilsReadSdgsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/utils/sdgs',
    });
  }

  /**
   * Read Referentials Keys
   * Retrieve referentials keys.
   * @param data The data for the request.
   * @param data.referential
   * @param data.key
   * @returns ReferentialsKeysPublic Successful Response
   * @throws ApiError
   */
  public static readReferentialsKeys(
    data: UtilsReadReferentialsKeysData = {}
  ): CancelablePromise<UtilsReadReferentialsKeysResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/utils/referentials_keys',
      query: {
        referential: data.referential,
        key: data.key,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }

  /**
   * Read Referentials
   * Retrieve comany referentials.
   * @param data The data for the request.
   * @param data.companySlug
   * @returns GlobalReferentialsPublic Successful Response
   * @throws ApiError
   */
  public static readReferentials(data: UtilsReadReferentialsData): CancelablePromise<UtilsReadReferentialsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/utils/{companySlug}/referentials',
      query: {
        company_slug: data.companySlug,
      },
      errors: {
        422: 'Validation Error',
      },
    });
  }
}
